import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const SERVICE_CONFIGS = [
  { icon: 'ri-road-map-line', titleKey: 'services_0_title', descKey: 'services_0_desc' },
  { icon: 'ri-user-star-line', titleKey: 'services_1_title', descKey: 'services_1_desc' },
  { icon: 'ri-shield-check-line', titleKey: 'services_2_title', descKey: 'services_2_desc' },
  { icon: 'ri-customer-service-2-line', titleKey: 'services_3_title', descKey: 'services_3_desc' },
  { icon: 'ri-wifi-line', titleKey: 'services_4_title', descKey: 'services_4_desc' },
  { icon: 'ri-luggage-cart-line', titleKey: 'services_5_title', descKey: 'services_5_desc' },
];

export default function ServicesSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <section
      id="services"
      ref={ref as React.RefObject<HTMLElement>}
      className={`w-full bg-white py-24 lg:py-32 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase mb-4">
            {t('services_eyebrow')}
          </p>
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-[#1a1a1a] mb-5">
            {t('services_h2_line1')}
            <span className="block text-[#C9A84C]">{t('services_h2_line2')}</span>
          </h2>
          <p className="text-[#777] text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            {t('services_subtitle')}
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {SERVICE_CONFIGS.map((service) => (
            <div
              key={service.titleKey}
              className="group bg-[#FAFAFA] border border-[#F0EDE8] rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 hover:border-[#C9A84C]/30 cursor-default"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#C9A84C]/10 rounded-xl mb-6 group-hover:bg-[#C9A84C]/20 transition-colors duration-300">
                <i className={`${service.icon} text-[#C9A84C] text-2xl`} />
              </div>
              <h3 className="font-playfair text-xl font-bold text-[#1a1a1a] mb-3">
                {t(service.titleKey)}
              </h3>
              <p className="text-[#777] text-sm leading-relaxed">
                {t(service.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
